const Productdetail = [

{
    id : 0,
    Image:require('./Imagesfolder/productone.png'),
    shoename:"Nike Air Force 1 Low By You",
    price:10795,
    count:1
},
{
    id : 1,
    Image:require('./Imagesfolder/producttwo.png'),
    shoename:"Nike Air Force 1 '07 LV8",
    price:10765,
    count:1
},
{
    id : 2,
    Image:require('./Imagesfolder/productthree.png'),
    shoename:"Nike Air Force 1 GTX",
    price:14995,
    count:1
},
{
    id : 3,
    Image:require('./Imagesfolder/productfour.png'),
    shoename:"Nike Pegasus Trail 4",
    price:10017,
    count:1
},
{
    id : 4,
    Image:require('./Imagesfolder/productfive.png'),
    shoename:"Nike Air Pegasus '89",
    price:9596,
    count:1
},
{
    id : 5,
    Image:require('./Imagesfolder/productsix.png'),
    shoename:"Nike Air Pegasus Trail 6",
    price:10117,
    count:1
},
{
    id : 6,
    Image:require('./Imagesfolder/productseven.png'),
    shoename:"Nike Air Max Solo",
    price:8695,
    count:1
},
{
    id : 7,
    Image:require('./Imagesfolder/producteight.png'),
    shoename:"Nike Air Max Alpha Trainer 5",
    price:7495,
    count:1
},
{
    id : 8,
    Image:require('./Imagesfolder/productnine.png'),
    shoename:"Nike Air Max LTD 3",
    price:10995,
    count:1
},
{
    id : 9,
    Image:require('./Imagesfolder/productten.png'),
    shoename:"Nike SB Dunk High Pro",
    price:10795,
    count:1
},{
    id : 10,
    Image:require('./Imagesfolder/producteleven.png'),
    shoename:"Nike Dunk High Retro SE",
    price:11495,
    count:1
},{
    id : 11,
    Image:require('./Imagesfolder/producttwelve.png'),
    shoename:"Nike Dunk High Retro Premium",
    price:10917,
    count:1
}
]


export default Productdetail;